export { GdprRestrictedButton } from './GdprRestrictedButton';
